import React from 'react';
import { Route } from 'react-router-dom';
import store from 'store2';
import config from '../../config';
import Login from './Login';

export default ({ component, ...rest }) => (
  <Route
    {...rest}
    render={props => React.createElement(store.get(config.auth.idTokenKey) ? component : Login, props)}
  />
);



// WEBPACK FOOTER //
// ./src/common/auth/PrivateRoute.js